export const isLoading = state => state.isLoading;

export const getLastFailure = state => state.lastFailure;

export const getReports = state => state.reports;

export const getReportToken = state => state.reportToken;